<template>
    <div class="side_bar">
        <!--<el-button icon="el-icon-more" @click="collapse = !collapse"></el-button>-->
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse" background-color=""
                 text-color="" active-text-color="" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title" class="sidebar-item-font">{{ item.title }}</span>
                        </template>

                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template slot="title">{{ subItem.title }}
                                </template>
                                <el-menu-item v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">
                                {{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>

                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title" class="sidebar-item-font">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import bus from "./Eventbus";

    export default {
        data() {
            return {
                collapse: false,
                items: [
                    // {
                    //     icon: "el-icon-lx-home",
                    //     index: "dashboard",
                    //     title: "系统首页"
                    // },
                    {
                        icon: "iconfont icon-ren2",
                        index: "plant",
                        title: "种植基础",
                        subs: [
                            {
                                index: "/crop",
                                title: "作物配置"
                            },
                            {
                                index: "/plantScheme",
                                title: "种植方案"
                            },
                            {
                                index: "/plantTask",
                                title: "种植任务"
                            },
                        ]
                    },
                    {
                        icon: "iconfont icon-fenlei",
                        index: "greenhouse",
                        title: "大棚管理"
                    },
                    {
                        icon: "iconfont icon-querenzhongbiao",
                        index: "checkStatistics",
                        title: "审阅统计"
                    },
                    {
                        icon: "iconfont icon-ren2",
                        index: "user",
                        title: "用户管理",
                        subs: [
                            {
                                index: "farmer",
                                title: "农户管理"
                            },
                            {
                                index: "expert",
                                title: "专家管理"
                            },
                        ]
                    },
                    {
                        icon: "iconfont icon-jichu",
                        index: "sysconfig",
                        title: "基础配置",
                        subs: [
                            {
                                index: "greenhousetype",
                                title: "大棚类型管理"
                            },
                            {
                                index: "deviceType",
                                title: "设备类型管理"
                            },
                            {
                                index: "question",
                                title: "问题管理"
                            },
                        ]
                    },
                    {
                        icon: "iconfont icon-fenlei",
                        index: "course",
                        title: "课程"
                    },
                    /*
                    {
                      icon: "el-icon-lx-message",
                      index: "sysmessage",
                      title: "系统消息"
                    },
                    */
                ]
            };
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace("/", "");
            }
        },
        // methods: {
        //   logout(index) {
        //     if (index == "logout") {
        //       localStorage.removeItem("ms_username");
        //       this.$router.push("/login");
        //     }else{
        //       return;
        //     }
        //   }
        // },
        created() {
            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on("collapse", msg => {
                this.collapse = msg;
            });
        }
    };
</script>

<style lang="scss" scoped>
    // @import "../../../../public/css/common";
    .el-menu{
        .iconfont{
            font-size: 20px;
            margin-right: 4px;
        }
        border-right: none !important;
    }

</style>
